import EcsInternalBusinessContact from './EcsInternalBusinessContact';
import { CONTACT_TYPE } from '@/constants/contactConstants';

export default class EcsBusinessProcessContact extends EcsInternalBusinessContact {
  get contactType() {
    return CONTACT_TYPE.businessProcess;
  }

  /**
   * Compares two given BusinessProcessContact objects for order.
   * Returns a negative integer, zero, or a positive integer as ContactA object is less than,
   * equal to, or greater than ContactB object.
   *
   * @param {EcsBusinessProcessContact} contactA
   * @param {EcsBusinessProcessContact} contactB
   *
   * @returns {Number}
   */
  static compare(contactA, contactB) {
    const comparableFieldsA = (contactA.name || '').toUpperCase();
    const comparableFieldsB = (contactB.name || '').toUpperCase();

    if (comparableFieldsA < comparableFieldsB) {
      return -1;
    }
    if (comparableFieldsA > comparableFieldsB) {
      return 1;
    }
    return 0;
  }
}
